import type { Quote } from "./types";
import { createQuoteStory } from "./types";

export const tawakkalSalmanFarisi: Quote = {
  id: "tawakkal-salman-farisi",
  name: "Salman al-Farisi: Meninggalkan Segalanya demi Kebenaran",
  emoji: "🌟",
  category: "Sabar & Tawakkal",
  description:
    "Dari bangsawan Persia ke budak, dari budak ke sahabat Nabi ﷺ. Salman al-Farisi **meninggalkan harta dan tanah air** demi mencari kebenaran — dan Allah **membalas dengan kehormatan yang tak terbayangkan**.",
  detail:
    "Kisah Salman al-Farisi radhiyallahu 'anhu, sahabat Nabi ﷺ yang paling terkenal dari Persia. Ia meninggalkan kehidupan bangsawan dan agama Zoroaster, belajar dari pendeta-pendeta Kristen, dijual sebagai budak, hingga akhirnya sampai di Madinah dan menemukan Nabi Muhammad ﷺ. Rasulullah ﷺ memujinya: \"Seandainya iman itu berada di bintang Tsurayya, niscaya orang dari Persia ini akan meraihnya.\" Rasulullah ﷺ bahkan menyebutnya sebagai bagian dari keluarga beliau, dan ia menjadi gubernur Persia — tanah yang dulu ia tinggalkan sebagai pelarian.",
  tldr: "Salman meninggalkan segalanya demi kebenaran — Allah membalasnya dengan kehormatan yang melampaui semua yang ia tinggalkan.",
  story: createQuoteStory("Salman al-Farisi", "🌟", [
    { hook: {
      title: "Puluhan tahun mencari kebenaran.",
      body: "Ini kisah **Salman al-Farisi**.",
    } },
    { insight: {
      title: "Persia → Syam → entah ke mana",
      body: "Salman lahir bangsawan Persia. Suatu hari ia melihat ibadah orang Kristen — dan hatinya tertarik.\n\nAyahnya murka, **mengurungnya di rumah**. Tapi Salman **melarikan diri**, meninggalkan segalanya.",
    } },
    { insight: {
      title: "Dari satu guru ke guru lain",
      body: "Bertahun-tahun Salman berpindah dari satu pendeta ke pendeta lain di tanah Syam.\n\nBahkan saat menemukan pendeta yang korup, imannya **tidak goyah** — ia tetap belajar, **menunggu guru yang jujur**.",
    } },
    { insight: {
      title: "Pesan terakhir sang pendeta",
      body: "Guru terakhirnya berpesan sebelum wafat: \"Nabi terakhir akan muncul di **negeri kurma**.\"\n\nTandanya tiga — **menolak sedekah, menerima hadiah**, dan ada tanda kenabian di punggungnya.",
    } },
    { insight: {
      title: "Dijual sebagai budak",
      body: "Salman membayar kafilah Arab untuk mengantarnya ke negeri kurma.\n\nTapi mereka **mengkhianatinya dan menjualnya sebagai budak**.\n\nIa berakhir di Yatsrib — dan saat melihat kebun kurmanya, hatinya tahu: **ini tempatnya.**",
    } },
    { reveal: {
      title: "Akhirnya, ketemu.",
      body: "Saat Nabi ﷺ hijrah ke Madinah, Salman **menguji tiga tanda itu satu per satu**.\n\nSedekah — Nabi menolak.\nHadiah — Nabi menerima.\nTanda di punggung — **terbukti ada.**\n\nSalman menangis dan memeluk Nabi ﷺ.",
    } },
    { engagement: {
      title: "Puluhan tahun ia mencari.",
      body: "Dan Allah mempertemukannya.\n\nSiapa yang sungguh-sungguh mencari kebenaran — **tidak akan pernah ditinggalkan**.",
    } },
  ]),
  tiktok: {
    title: "Puluhan tahun mencari kebenaran. Ini kisah Salman al-Farisi.",
    description: "Dari bangsawan Persia, dikhianati jadi budak, sampai akhirnya menemukan Nabi ﷺ di Madinah. Kisah pencarian kebenaran yang paling epik dalam sejarah Islam.\n\n#salman #salmanalfarisi #sahabat #kisahislam #islam #islamichistory #sirahnabi #hijrah #tawakkal #kebenaran #fyp",
  },
  related: ["sabar-baqarah-153", "urusan-mukmin-muslim"],
};
